// @flow
import React from 'react';
import Debug from 'debug';
import VectorSource from 'ol/source/Vector';
import { ZINDEX } from '../../../constants/appConstants';
import { layers, interactions } from '../../ui/openlayers';
import { StyleProvider } from './styleContext';
import Cars from './Cars';
import Planes from './Planes';
import { TrailsProvider } from './Trail';
import createClusterSource from './clusterSource';

const debug = Debug('amms:modules:map:targets');

const _SOURCE = {
    type: null,
    data: null
};
const getSource = (clusteringEnabled: boolean) => {
    if(clusteringEnabled) {
        if(_SOURCE.type !== 'clustered' || !_SOURCE.data) {
            _SOURCE.type = 'clustered';
            _SOURCE.data = createClusterSource();
        }

        return _SOURCE.data;
    }
    else {
        if(_SOURCE.type !== 'unclustered' || !_SOURCE.data) {
            _SOURCE.type = 'unclustered';
            _SOURCE.data = new VectorSource();
        }

        return _SOURCE.data;
    }
};

const filterDraggableLabels = (feature) => feature.get('type') === 'draggableLabel';

type LabelConfig = $ReadOnly<{
    enabled: boolean,
    cluster: boolean,
    labelType: 'normal' | 'draggable'
}>;

export type Props = $ReadOnly<{
    labelConfig: LabelConfig,
    carLabelConfig: LabelConfig,
    planeLabelConfig: LabelConfig,
    drawingEnabled: boolean
}>;

function Targets({ labelConfig, drawingEnabled }: Props) {
    const clusteringEnabled = labelConfig.labelType === 'normal' && labelConfig.cluster;
    const draggableLabels = Boolean(labelConfig.enabled && labelConfig.labelType === 'draggable');

    return (
        <StyleProvider baseZoom={15} labelConfig={labelConfig}>
            <layers.Vector label="targets" source={getSource(clusteringEnabled)} zIndex={ZINDEX.targets}>
                {!drawingEnabled && <interactions.Select label="targets" style={null} />}
                {draggableLabels && <interactions.Translate label="targets" filter={filterDraggableLabels} />}

                <TrailsProvider>
                    <Cars />
                    <Planes />
                </TrailsProvider>
            </layers.Vector>
        </StyleProvider>
    );
}

export default Targets;